import { render, staticRenderFns } from "./WebLinks.vue?vue&type=template&id=377fc490&"
import script from "./WebLinks.vue?vue&type=script&lang=js&"
export * from "./WebLinks.vue?vue&type=script&lang=js&"
import style0 from "./WebLinks.vue?vue&type=style&index=0&id=377fc490&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports